import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationDto } from 'app/models/configuration/configuration-dto';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppConfigService } from '../app-config/app-config.service';
import { AbstractHttpService } from '../base/abstract.http.service';
import { CONFIGURATION, RECEIVING_CONDITIONS } from '../base/service-const';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService extends AbstractHttpService<any> {

    constructor(
        protected _httpClient: HttpClient,
        private appConfigService: AppConfigService
    ) {
        super(_httpClient, CONFIGURATION, appConfigService.apiBaseUrl);
    }

    getConfigurations(): Observable<any> {
        return this.customRead('config-web').pipe(take(1));
    }

    saveConfiguratios(configurationDto: ConfigurationDto): Observable<any> {
        return this.create(configurationDto, 'configurations').pipe(take(1));
    }

    saveImgConfigurations(name: string, type: string, item): Observable<any> {
        return this.saveImgConfiguration('attachments', name, type, item).pipe(take(1));
    }

}